import {
  BACKGROUND_LAYER_TYPE,
  ENVELOPE_PAPER_LAYER_TYPE,
  PAPER_LAYER_TYPE,
  UYO_PAPER_LAYER_TYPE,
} from '../constants';

export function isBackground(layer, excludePaper) {
  const type = layer && (layer?.type || layer?.display?.type);
  const bgTypes = [BACKGROUND_LAYER_TYPE, 'background'];
  if (!excludePaper)
    bgTypes.push(PAPER_LAYER_TYPE, ENVELOPE_PAPER_LAYER_TYPE, UYO_PAPER_LAYER_TYPE);
  return bgTypes.includes(type);
}

export const applyToVals = (fn, obj) => {
  let o = {};
  for (let k in obj) if (obj.hasOwnProperty(k)) o[k] = fn(obj[k]);
  return o;
};
